import {
  SupportTicketCategory,
  SupportTicketImpact,
  SupportTicketStatus,
} from '../../../shared/interfaces';

export interface CategoryOption {
  value: SupportTicketCategory;
  label: string;
  hint: string;
  /** SVG path (24x24, stroke) */
  icon: string;
}

export const SUPPORT_CATEGORIES: CategoryOption[] = [
  {
    value: 'agenda',
    label: 'Agenda y citas',
    hint: 'Crear, mover o ver citas',
    icon: 'M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5',
  },
  {
    value: 'clients',
    label: 'Clientes',
    hint: 'Fichas, historial, datos',
    icon: 'M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z',
  },
  {
    value: 'payments',
    label: 'Pagos y membresía',
    hint: 'Cobros, plan, facturas',
    icon: 'M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z',
  },
  {
    value: 'notifications',
    label: 'Recordatorios',
    hint: 'WhatsApp y correos',
    icon: 'M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0',
  },
  {
    value: 'microsite',
    label: 'Página de reservas',
    hint: 'Tu sitio público',
    icon: 'M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418',
  },
  {
    value: 'account',
    label: 'Mi cuenta',
    hint: 'Acceso, perfil, equipo',
    icon: 'M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z',
  },
  {
    value: 'other',
    label: 'Otra cosa',
    hint: 'Dudas o sugerencias',
    icon: 'M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z',
  },
];

export const SUPPORT_IMPACTS: { value: SupportTicketImpact; label: string; hint: string }[] = [
  { value: 'low', label: 'Es una duda o algo menor', hint: 'Puedo seguir trabajando con normalidad' },
  { value: 'medium', label: 'Me complica el trabajo', hint: 'Encontré un rodeo, pero me quita tiempo' },
  { value: 'high', label: 'No puedo trabajar', hint: 'Mi agenda o mis clientes están afectados' },
];

/** Ordered steps of the ticket lifecycle, as the user sees them */
export const SUPPORT_STEPS: { status: SupportTicketStatus; label: string }[] = [
  { status: 'open', label: 'Recibido' },
  { status: 'in_progress', label: 'En revisión' },
  { status: 'waiting_user', label: 'Te escribimos' },
  { status: 'resolved', label: 'Resuelto' },
];

export function categoryLabel(value: SupportTicketCategory): string {
  return SUPPORT_CATEGORIES.find((c) => c.value === value)?.label ?? 'Otra cosa';
}

export function impactLabel(value: SupportTicketImpact): string {
  return SUPPORT_IMPACTS.find((i) => i.value === value)?.label ?? '';
}

export function statusLabel(status: SupportTicketStatus): string {
  switch (status) {
    case 'open':
      return 'Recibido';
    case 'in_progress':
      return 'En revisión';
    case 'waiting_user':
      return 'Necesitamos tu respuesta';
    case 'resolved':
      return 'Resuelto';
    default:
      return 'Cerrado';
  }
}

export function ticketCode(ticketNumber: number): string {
  return `#${String(ticketNumber).padStart(4, '0')}`;
}
